export let CombatPhaseLength;

(function (CombatPhaseLength) {
  CombatPhaseLength[CombatPhaseLength["Short"] = 0] = "Short";
  CombatPhaseLength[CombatPhaseLength["Long"] = 1] = "Long";
})(CombatPhaseLength || (CombatPhaseLength = {}));